// Date helpers for the hotel app.
// The hotel operates on America/Chicago (Central Time). All "today" calculations
// must use Central Time so that, for example, 7:15pm Central on Apr 26 returns
// "2026-04-26" rather than "2026-04-27" (which is what UTC would give).

const HOTEL_TIMEZONE = 'America/Chicago';

/**
 * Returns today's date in the hotel timezone formatted as YYYY-MM-DD.
 * Use this everywhere we previously did `new Date().toISOString().split('T')[0]`
 * to avoid the late-evening UTC rollover bug.
 */
export const getCentralToday = () => {
  // 'en-CA' locale formats dates as YYYY-MM-DD natively.
  return new Date().toLocaleDateString('en-CA', { timeZone: HOTEL_TIMEZONE });
};

/**
 * Returns the current month in the hotel timezone formatted as YYYY-MM.
 * Use this for `<Input type="month">` defaults to avoid showing next month
 * when the UTC-rollover happens late in the evening.
 */
export const getCentralMonth = () => {
  return getCentralToday().slice(0, 7);
};

/**
 * Returns the current time in the hotel timezone formatted as HH:MM (24h).
 */
export const getCentralTimeHHMM = () => {
  return new Date().toLocaleTimeString('en-GB', {
    timeZone: HOTEL_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};
